import React from 'react';
import './styles.css';
import { Button } from '@mui/material';
import notFound from './404.svg';
import logo from '../../assets/bancame_logo_dark.svg';
import { Partner } from '../../components/LeadFormIndex/types';
import getPartnerButton from '../../components/PartnerButtons';
import BancameBackdrop from '../../components/BancameBackdrop';

function NotFound(params:{ partnerData?: Partner }) {
  const { partnerData } = params;
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    document.body.style.backgroundColor = '#E5E5E5';
  }, []);
  const redirectToLanding = () => {
    window.location.href = partnerData?.config.website ?? 'https://banca.me';
  };
  React.useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  if (loading) {
    return (
      <BancameBackdrop
        openBackdrop={loading}
        type="loading"
        customLogo={null}
      />
    );
  }

  return (
    <div className="products_body">
      <div>

        <object
          style={{ width: '200px' }}
          data={partnerData?.config.styles?.headerLogo ?? logo}
          className="mainLogo"
          aria-labelledby="headerLogo"
        />
        <div className="cards_container">
          <div>
            <object
              data={notFound}
              aria-labelledby="notFound"
              className="notFound"
            />

          </div>
          <div>
            <h1>¡Nos perdimos!</h1>
            <h3>Esta página no existe</h3>

            {partnerData ? getPartnerButton({
              partner: partnerData,
              disabled: false,
              onClick: redirectToLanding,
              buttonLabel: `Volver a ${partnerData?.partnerName ?? 'banca.me'}`,
              testingLabel: 'cu-submit-button',
            })
              : (
                <Button
                  className="notFoundButton"
                  onClick={redirectToLanding}
                  color="primary"
                  variant="contained"
                >
                  <span>
                    Volver a
                  </span>

                  <span style={{ marginLeft: '5px' }}>banca.me</span>
                </Button>
              )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default NotFound;
